module.exports = __webpack_public_path__ + "img/favicon 512.5b0a34ae.png";